import { css } from '@emotion/react'
import colors from '~/styles/colors'

export const iconFinish = css`
  color: ${colors.green};
  font-size: 0.9rem;
`
